export enum ItemizedBillFormat {
    NONE = 0,
    COMPLETE = 1,
    SHORTENED = 2,
}
